export default "__VITE_ASSET__Bt7cEKOt__"